import React, { useState } from 'react';
import { Table } from 'antd';
import { useT } from 'hooks/Locale/useT';
import moment from 'moment';
import CommentModal from '../Modals/CommentModal';
import generalHelpers from 'utils/generalHelpers';

interface ScormTestTableInterface {
    data: any[];
}

const ScormTestTable: React.FC<ScormTestTableInterface> = ({ data }) => {
    const t = useT();
    const [showCommentModal, setShowCommentModal] = useState<any>([]);

    const defaultExpandable = {
        expandedRowRender: (record: any) => {
            return Object.entries(record.responses).map((userResponse: any) => {
                const response = userResponse[1];
                return (
                    <div className={'flex justify-between student-response-wrapper gap-20 p-5'}>
                        <div>{parseInt(userResponse[0]) + 1}</div>
                        <div className={'flex flex-column gap-5 w-35'}>
                            <span></span>
                            <span>{response.question}</span>
                        </div>
                        <div className={'flex flex-column gap-5 w-35'}>
                            <span>{t('courses.export.answer')}</span>
                            <span>{response.learnerResponse}</span>
                        </div>
                        <div className={'flex flex-column gap-5'}>
                            <span>{t('question_pools.score')}</span>
                            <span>{response?.points}</span>
                        </div>
                    </div>
                );
            });
        },
    };

    const columns = [
        {
            title: t('program.attempt'),
            render: (_text: string, record: any) =>
                t('program.attempt_count', { attempt: record.attempt }),
        },
        {
            title: t('student.result'),
            dataIndex: 'result',
            render: (result: number) => (result ? result + '%' : '-'),
        },
        {
            title: t('program.attempt_start'),
            dataIndex: 'attemptStart',
            key: 'attemptStart',
            render: (date: string) => (date ? moment(date).format('YYYY-MM-DD HH:mm') : '-'),
        },
        {
            title: t('program.attempt_end'),
            dataIndex: 'attemptEnd',
            key: 'attemptEnd',
            render: (date: string) => (date ? moment(date).format('YYYY-MM-DD HH:mm') : '-'),
        },
        {
            title: t('program.result_comment'),
            render: (_text: string, record: any) => (
                <div
                    className={'pointer'}
                    onClick={() => (record?.comment ? setShowCommentModal(record.comment) : null)}
                >
                    <i className="fa-sharp fa-regular fa-comment-check"></i>
                </div>
            ),
        },
        {
            title: t('program.total_time_spent'),
            dataIndex: 'timeSpent',
            render: (time: number) => (time ? generalHelpers.toHoursAndMinutes(time) : '-'),
        },
    ];

    return (
        <>
            <Table
                columns={columns}
                expandable={defaultExpandable}
                dataSource={data}
                rowKey="id"
                pagination={{ position: [] }}
            />
            <CommentModal open={showCommentModal} onCancel={setShowCommentModal} />
        </>
    );
};

export default ScormTestTable;
